import React from 'react';
import ScrollAnimation from "react-animate-on-scroll";
import { FiCheck } from 'react-icons/fi';

const TimelineData = [
    {
        id: "1",
        title: "Proceso de Inducción:",
        description: "Realizamos la definición del puesto con el superior directo, colaboración activa en descripciones de puesto y planificación del trabajo en equipo. ",
    },
    {
        id: "2",
        title: "Integración Efectiva:",
        description: "Nos presentamos el día del ingreso para la clarificación del entrenamiento, los horarios y el seteo de las expectativas del nuevo miembro del equipo.",
    },
    {
        id: "3",
        title: "Coaching 1er mes:",
        description: "Evaluación formal de desempeño y ajustes finales en la integración. Identificación de oportunidades de desarrollo y reforzamiento de la cultura organizacional.",
    },
    {
        id: "4",
        title: "Evaluación:",
        description: "Durante los primeros 3 meses nos mantenemos en contacto conteniendo y encauzando mediante gastromentorias.",
    }
    
]

const TimelineTwo = ({classVar}) => {
    return (
        <div>
        <div className="timeline-style-two bg-color-lightwhite">
            <div className="row row--0">
                {/* Start Single Progress */}
                {TimelineData.map((data , index) =>(
                    <div className={`col-lg-3 col-md-3 rn-timeline-single ${classVar}`} key={index}>
                        <div className="rn-timeline">
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <h5 className="p2-azul">{data.title}</h5>
                            </ScrollAnimation>
                            <div className="progress-line">
                                <div className="line-inner"></div>
                            </div>
                            <div className="progress-dot">
                                <div className="dot-level">
                                    <div className="dot-inner"></div>
                                </div>
                            </div>
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <p className="description" style={{color:"#001997"}}>{data.description}</p>
                                 </ScrollAnimation>
                   </div>
                    </div>
                ))}
                {/* End Single Progress */}
            </div>
        </div>
        <br/>
        <p className="p6-white"><span className="icon-check"><FiCheck /></span> 3 meses de gastromentorías  :</p> <p className="p3-white">Donde trabajaremos con el candidato en sesiones individuales monitoreando su desempeño inicial. </p>
        
        <p className="p6-white"><span className="icon-check"><FiCheck /></span>3 meses de garantía única:</p>  <p className="p3-white">Si el candidato se va o se decide que no continúe, nos comprometemos realizar una nueva búsqueda sin costo adicional. </p>
        </div>
    )
}
export default TimelineTwo;